import get from 'lodash/get';
import createMappedReducer from 'src/common/reducers/utils/createMappedReducer';

import { GET_PRODUCTS_BY_SKUS } from '../actions/products';
import filterProductsBySkus from '../utils/subscription/filterProductsBySkus';
import billingPeriods from '../utils/subscription/billingPeriod';
import findProductWithSameBillingPeriod from '../utils/subscription/findProductWithSameBillingPeriod';
import { isMonthlyTrial } from '../components/utils/subscriptionProductDetails';
import { fulfilled } from './utils/asyncActionNameSuffixes';
import createRequestLifecycleHandlers from './utils/createRequestLifecycleHandlers';

const getClientProductModel = (product = {}, standardProducts) => {
  const {
    sku,
    currencyCode,
    price,
    isFree,
    freeTrialLength,
    freeTrialPeriod,
    formattedPrice,
    formattedDiscountedPrice,
    hasSetupFee,
    formattedSetupPrice,
    countryCode,
    currencies,
    billingPeriod,
    requiresBillingInfo,
    discountFreeTrialLength,
  } = product;
  const standardProduct =
    findProductWithSameBillingPeriod(standardProducts, product) || {};
  const { price: stdUnformattedPrice, formattedPrice: stdFormattedPrice } =
    standardProduct;
  const unformattedPrice =
    get(product, ['discountedCurrencies', currencyCode]) || price;

  return {
    sku,
    billingPeriod,
    countryCode,
    currencies,
    currencyCode,
    requiresBillingInfo,
    hasCouponBeenApplied: !!(
      formattedDiscountedPrice || discountFreeTrialLength
    ),
    freeTrialLength: discountFreeTrialLength || freeTrialLength,
    price: formattedDiscountedPrice || formattedPrice,
    setupPrice: hasSetupFee ? formattedSetupPrice : 0,
    isFree: !!isFree,
    isMonthlyTrial:
      isMonthlyTrial(product) || freeTrialPeriod === billingPeriods.monthly,
    hasTrial: parseInt(freeTrialLength, 10) !== 0,
    standardProductPrice: stdFormattedPrice,
    hasPriceDiscount: unformattedPrice < stdUnformattedPrice,
  };
};

export const products = createMappedReducer(
  {},
  {
    ...createRequestLifecycleHandlers({
      fetchActionNameRoot: GET_PRODUCTS_BY_SKUS,
    }),
    [fulfilled(GET_PRODUCTS_BY_SKUS)](state, action) {
      const allProducts = {};
      const finalProducts = {};

      action.payload.content.forEach((item) => {
        allProducts[item.sku] = item;
      });

      const skuMeta = action.meta.skuMeta;
      const standardProducts = filterProductsBySkus(
        allProducts,
        skuMeta.defaultSkus,
      );
      const productsFromQuery = filterProductsBySkus(
        allProducts,
        skuMeta.fromQuery,
      );
      const productsToUse = productsFromQuery.length
        ? productsFromQuery
        : standardProducts;

      productsToUse.forEach((product) => {
        finalProducts[product.sku] = {
          isFetching: false,
          ...getClientProductModel(product, standardProducts),
          isRenew: skuMeta.isRenew,
        };
      });

      return finalProducts;
    },
  },
);
